module.exports = __webpack_public_path__ + "static/media/money.3ac6301c.svg";